import {Injectable, signal} from '@angular/core';
import {AnyLinkType} from './models';

@Injectable({
  providedIn: 'root'
})
export class PrettyEasyNavigationService {
    private writableMenu = signal<AnyLinkType[]>([]);
    public menu = this.writableMenu.asReadonly();

    public setMenu(menu: AnyLinkType[]): void {
        this.writableMenu.set(menu);
    }
}
